<template>
  <div>
    <v-container grid-list-xl fluid>
        <!-- <v-flex lg2 pr-6><v-select
              label="Nhân viên"
              :items="staff_options"
              v-model="staffName"
              item-text="Username"
              item-value="Username"
            ></v-select>
        </v-flex>
        <v-flex lg2 pr-6>
            <v-select
              label="Hình thức"
              :items="method_options"
              v-model="method"
              item-text="name"
              item-value="value"
            ></v-select>
        </v-flex> -->
        <v-layout row wrap>
            <v-flex lg3 pl-6>
                <v-layout row wrap justify-end>
                    <v-menu
                        v-model="menuStart"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            v-model="computedStartDateFormatted"
                            label="Từ ngày"
                            hint="DD-MM-YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                    </v-menu>
                </v-layout>
            </v-flex>
            <v-flex lg3 pl-6>
                <v-layout row wrap justify-end>
                    <v-menu
                        v-model="menuEnd"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            v-model="computedEndDateFormatted"
                            label="Đến ngày"
                            hint="DD-MM-YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                    </v-menu>
                </v-layout>
            </v-flex>
            <v-flex lg2 pl-6 pt-0 v-if="roleAdmin">
                <v-select label="Báo cáo theo" :items="report_types" v-model="reportType" item-text="name" item-value="value"></v-select>
            </v-flex>
            <v-flex lg2 pl-6 pt-0 v-if="reportType !== 'all' && roleAdmin">
                <v-autocomplete :label="user_title" :items="user_list" v-model="uidSelected" item-text="Username" item-value="ID"></v-autocomplete>
            </v-flex>
            <v-flex lg2 pl-6>
                <v-btn @click="filter_data" color="#a41c21" outlined>Xem</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg12 v-if="items">
                <v-data-table hide-default-footer :headers="headers" :items="items" :server-items-length="items.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ReportDate }}</td>
                            <td class="text-end">{{ item.NumberOfCode | currency }}</td>
                            <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                            <td class="text-end">{{ item.Weight | currency('', 1) }}</td>
                            <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                            <td class="text-end">{{ item.Deposit | currency('¥', 1) }}</td>
                            <td class="text-end">{{ item.FeeShipVND | currency }}</td>
                            <td class="text-end">{{ item.DiscountAmount | currency }}</td>
                            <td class="text-end">{{ item.AmountVND | currency }}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td class="font-weight-bold">TỔNG</td>
                            <td class="text-end font-weight-bold">{{dic_summary.NumberOfCode | currency}}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.NumberOfPack | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Weight | currency('', 1) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Volume | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.Deposit | currency('¥', 1) }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.FeeShipVND | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.DiscountAmount | currency }}</td>
                            <td class="text-end font-weight-bold">{{ dic_summary.AmountVND | currency }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            viewName: "thong-ke-nap-tien",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            recharge_methods: configs.RECHARGE_METHODS,
            staffName: '',
            method: 0,
            report_types: [{'value': 'all', 'name': 'Công ty'}, {'value': 'customer', 'name': 'Khách hàng'}, {'value': 'sale', 'name': 'Sale'}],
            reportType: 'all',
            user_list: [],
            uidSelected: 0,
            user_title: 'Chọn khách hàng'
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        reportType() {
            if(this.reportType == 'customer') {
                this.user_title = 'Chọn khách hàng';
                this.user_list = this.customers;
            }
            else if(this.reportType == 'sale') {
                this.user_title = 'Chọn sale';
                this.user_list = this.staffs;
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.report.revenues.data,
            loading: state => state.report.loading,
            staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (
                    o.RoleID == configs.ROLE_TYPE.Sale
                );
            }),
            customers: state => state.commons.customers,
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        roleAdmin() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Payment;
        },
        dic_summary() {
            return {
                'NumberOfCode': _.sumBy(this.items, 'NumberOfCode'),
                'NumberOfPack': _.sumBy(this.items, 'NumberOfPack'),
                'Weight': _.sumBy(this.items, 'Weight'),
                'Volume': _.sumBy(this.items, 'Volume'),
                'Deposit': _.sumBy(this.items, 'Deposit'),
                'FeeShipVND': _.sumBy(this.items, 'FeeShipVND'),
                'DiscountAmount': _.sumBy(this.items, 'DiscountAmount'),
                'AmountVND': _.sumBy(this.items, 'AmountVND'),
            };
        },
        headers() {
            return [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Số bill",
                    value: "NumberOfCode",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chi tệ",
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí ship",
                    value: "FeeShipVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chiết khấu",
                    value: "DiscountAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thành tiền",
                    value: "AmountVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
            ];
        },
        filter_params() {
            let param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                report_type: this.reportType,
                uidSelected: this.uidSelected,
                pagination: {
                    sortDesc: this.pagination.sortDesc,
                    sortBy: this.pagination.sortBy
                }
            }
            if(this.staffName != '') {
                param.staffName = this.staffName;
            }
            if(this.method != 0) {
                param.method = this.method;
            }
            return param;
        }
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("report/getRevenueReport", this.filter_params);
        },
        exportData() {
            this.$store.dispatch("report/exportList", this.filter_params);
        }
    },
    mounted() {
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("commons/getAllCustomer");
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_EXPORT_ACTION", this.exportData);
    }
};
</script>